import { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';
import { useLazyQuery } from "@apollo/client";
import { complaintByStatut } from "../graphql/queries";
import DashboardApp from "../components/admin/DashboardApp";
import { ROLES } from '../redux/auth/auth.actions';

const AdminDashboardPage = () => {
  const [retrieveBrute, { data: bruteData }] = useLazyQuery(complaintByStatut);
  const [retrieveTraitement, { data: traitementData }] =
    useLazyQuery(complaintByStatut);
  const [retrieveDelibere, { data: delibereeData }] =
    useLazyQuery(complaintByStatut);

  const [bruteInt, setBruteInt] = useState(0);
  const [traitementInt, setTraitementInt] = useState(0);
  const [delibereeInt, setDelibereeInt] = useState(0);

  useEffect(() => {
    retrieveBrute({
      variables: {
        statut: "Brute",
      },
    });
    if (
      bruteData &&
      bruteData.complaintByStatut &&
      bruteData.complaintByStatut.items
    ) {
      setBruteInt(bruteData.complaintByStatut.items.length);
    }
    retrieveTraitement({
      variables: {
        statut: "Traitement en cours",
      },
    });
    if (
      traitementData &&
      traitementData.complaintByStatut &&
      traitementData.complaintByStatut.items
    ) {
      setTraitementInt(traitementData.complaintByStatut.items.length);
    }
    retrieveDelibere({
      variables: {
        statut: "Délibérée",
      },
    });

    if (
      delibereeData &&
      delibereeData.complaintByStatut &&
      delibereeData.complaintByStatut.items
    ) {
      setDelibereeInt(delibereeData.complaintByStatut.items.length);
    }
  }, [
    bruteData,
    traitementData,
    delibereeData,
    retrieveBrute,
    retrieveTraitement,
    retrieveDelibere,
  ]);

  const dataStat = {
    data: [bruteInt, traitementInt, delibereeInt],
  };
  const userProfile = localStorage.getItem('userProfile');
  const hasRole = userProfile && userProfile ===  ROLES.CLIENT;

  if (hasRole) {
    return <Navigate to="/401" />;
  }



  return (
    <>
      {/* {alert(JSON.stringify(dataStat, null, 2))} */}
      <DashboardApp dataStat={dataStat.data} />
    </>
  );
};

export default AdminDashboardPage;
